var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 3.1875C4.95837 3.1875 1.93379 5.39042 0.708374 8.5C1.93379 11.6096 4.95837 13.8125 8.50004 13.8125C12.0417 13.8125 15.0663 11.6096 16.2917 8.5C15.0663 5.39042 12.0417 3.1875 8.50004 3.1875ZM8.50004 12.0417C6.54504 12.0417 4.95837 10.455 4.95837 8.5C4.95837 6.545 6.54504 4.95833 8.50004 4.95833C10.455 4.95833 12.0417 6.545 12.0417 8.5C12.0417 10.455 10.455 12.0417 8.50004 12.0417ZM8.50004 6.375C7.32421 6.375 6.37504 7.32417 6.37504 8.5C6.37504 9.67583 7.32421 10.625 8.50004 10.625C9.67587 10.625 10.625 9.67583 10.625 8.5C10.625 7.32417 9.67587 6.375 8.50004 6.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.7c849d6b11a390319d42a7e0ee747209.svg";
export { ForwardRef as ReactComponent };